module.exports = __webpack_public_path__ + "be0230d15b163a3b17b2c0d8f2074cfe.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-turkey-s.png
// module id = 2758
// module chunks = 0